import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { TaxonomyTerm } from 'src/app/shared/interfaces/taxonomy-term.interface'
import { Video } from 'src/app/shared/interfaces/video.interface'
import { MetaService } from 'src/app/shared/services/meta.service'
import { TagService } from 'src/app/shared/services/tag.service'
import { VideoService } from 'src/app/shared/services/video.service'
import { ExpertGroupPortalService } from '../../services/expert-group-portal.service'

@Component({
  selector: 'app-expert-group-portal-video-list',
  templateUrl: './expert-group-portal-video-list.component.html',
  styleUrls: ['./expert-group-portal-video-list.component.scss']
})
export class ExpertGroupPortalVideoListComponent implements OnInit {
  videos: Video[]
  loader: boolean
  baseUrl: string
  expertGroupPortal: ExpertGroupPortal

  constructor(
    private videoService: VideoService,
    private tagService: TagService,
    private metaService: MetaService,
    private router: Router,
    private expertGroupPortalService: ExpertGroupPortalService
  ) {}

  async ngOnInit() {
    // Get the current expert group portal
    this.baseUrl = await this.router.url.split('?')[0]

    // The id of the current expert group portal, it's always one string before the last slash
    const id: string = this.baseUrl.split('/').slice(-2)[0]

    this.expertGroupPortal =
      await this.expertGroupPortalService.getExpertGroupPortalById(id)

    const tagPromises: Promise<TaxonomyTerm>[] =
      this.expertGroupPortal.tagSlugs.map((tagSlug) =>
        this.tagService.showBySlug(tagSlug)
      )

    Promise.all(tagPromises).then((tags: TaxonomyTerm[]) => {
      const tagIds: number[] = tags.map((tag: TaxonomyTerm) => tag.id)
      this.loader = true
      ;(
        this.videoService.list({ tagIds, withoutPagination: true }) as Promise<
          Video[]
        >
      ).then((videos: Video[]) => {
        this.videos = videos
        this.loader = false
      })
    })

    this.metaService.setTags({
      title: `${this.expertGroupPortal.title} Videos`,
      description: `${this.expertGroupPortal.title} Videos`,
      path: `${this.expertGroupPortal.id}/videos `,
      absoluteOgImage: this.metaService.defaultMeta.absoluteOgImage
    })
  }
}
